import { useToggle } from '@veracity/ui-utils'
import { Box, Notification } from '@veracity/vui'
import { useParams } from 'react-router-dom'

import { PageContainer } from '@/components'

import {
  ScenarioComparisonOperations,
  ScenarioComparisonPreview
} from './components'
import { useScenarioComparison } from './hooks'

export const ScenarioComparisonPage = () => {
  const { joinedScenarioIds } = useParams()
  const scenarioIds = joinedScenarioIds?.split('+').map(x => +x) || []

  const [areAllRowsExpanded, toggleAreAllRowsExpanded] = useToggle(true)

  const {
    comparisonInfo,
    isFetching,
    isError,
    detailedComparisonInfo,
    downloadComparison,
    isDownloadComparisonInProgress
  } = useScenarioComparison(scenarioIds)

  return (
    <PageContainer
      loading={isFetching}
      header={
        <PageContainer.Breadcrumbs
          items={[
            { title: 'Projects', path: '/projects' },
            { title: 'Scenario Comparison' }
          ]}
        />
      }
      menuBar={
        <ScenarioComparisonOperations
          isError={isError}
          selectedScenarioIds={scenarioIds}
          onExpandAllRows={toggleAreAllRowsExpanded.on}
          onCollapseAllRows={toggleAreAllRowsExpanded.off}
          onPrintComparison={() => window.print()}
          onDownloadExport={downloadComparison}
          isDownloadExportInProgress={isDownloadComparisonInProgress}
        />
      }>
      {isError ? (
        <Box justifyContent="space-around">
          <Notification
            status="error"
            title="Comparison failed!"
            text="Please check selected scenarios ids and try again."
          />
        </Box>
      ) : (
        <ScenarioComparisonPreview
          areAllRowsExpanded={areAllRowsExpanded}
          comparisonInfo={comparisonInfo}
          scenarioComparisonGroupedAnnually={detailedComparisonInfo}
        />
      )}
    </PageContainer>
  )
}
